import { render, staticRenderFns } from "./ResubmissionModal.vue?vue&type=template&id=6b0a96b5&"
import script from "./ResubmissionModal.vue?vue&type=script&lang=js&"
export * from "./ResubmissionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports